import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Cosa sono le vetrate panoramiche VEPA?",
    a: "Le VEPA (Vetrate Panoramiche Amovibili) sono sistemi composti principalmente da pannelli in vetro trasparente progettati per proteggere e valorizzare spazi esterni come terrazzi, balconi, logge e porticati.\n\nA differenza delle chiusure tradizionali, sono caratterizzate da un design minimale, elevata trasparenza e possibilità di apertura completa dello spazio, mantenendo una continuità visiva tra interno ed esterno.",
  },
  {
    q: "Le vetrate panoramiche VEPA creano cubatura?",
    a: "Le VEPA sono progettate come sistemi amovibili e trasparenti, con l'obiettivo di proteggere gli spazi esterni senza creare un nuovo ambiente abitabile.\n\nLa normativa vigente prevede specifiche caratteristiche affinché tali sistemi possano rientrare nella definizione di VEPA, ma la valutazione finale dipende sempre dal contesto specifico dell'immobile, dai regolamenti edilizi comunali e da eventuali vincoli presenti.\n\nPer questo motivo consigliamo sempre una verifica preventiva della fattibilità dell'intervento.",
  },
  {
    q: "Le VEPA possono essere installate su un balcone?",
    a: "Sì. Le vetrate panoramiche sono una soluzione ideale per valorizzare balconi e logge, trasformandoli in spazi più confortevoli e protetti.\n\nLa progettazione viene effettuata su misura valutando:\n• dimensioni del balcone;\n• struttura esistente;\n• modalità di fissaggio;\n• esigenze estetiche e funzionali del cliente.",
  },
  {
    q: "Posso installare una VEPA su un terrazzo?",
    a: "Sì. Terrazzi e grandi spazi outdoor rappresentano uno degli ambienti più adatti per le vetrate panoramiche.\n\nUna VEPA permette di utilizzare maggiormente lo spazio esterno, creando una zona protetta dalla pioggia, dal vento e dalla polvere, senza perdere la luminosità e la vista panoramica.",
  },
  {
    q: "Quanto costa una vetrata panoramica VEPA?",
    a: "Il costo dipende da diversi elementi:\n• dimensioni dell'intervento;\n• numero delle ante;\n• sistema scelto (scorrevole o ad impacchettamento);\n• tipologia e spessore del vetro;\n• caratteristiche del luogo di installazione;\n• complessità della posa.\n\nOgni progetto viene valutato singolarmente per offrire una soluzione realmente su misura.",
  },
  {
    q: "È possibile avere un preventivo gratuito?",
    a: "Sì. Effettuiamo una valutazione preliminare e sviluppiamo una proposta personalizzata sulla base delle caratteristiche dello spazio da valorizzare.\n\nUn preventivo accurato permette di individuare la soluzione più adatta dal punto di vista estetico, tecnico ed economico.",
  },
  {
    q: "Le vetrate panoramiche proteggono dal freddo?",
    a: "Le VEPA migliorano sensibilmente il comfort dello spazio perché riducono l'esposizione a vento, pioggia e agenti atmosferici.\n\nNon sono però equivalenti a un serramento tradizionale ad alte prestazioni termiche e non sostituiscono una chiusura muraria isolata.\n\nLa loro funzione principale è creare un ambiente più confortevole, luminoso e vivibile durante un periodo molto più ampio dell'anno.",
  },
  {
    q: "Le VEPA proteggono dalla pioggia?",
    a: "Sì. Una corretta progettazione e installazione permette di ridurre notevolmente l'ingresso di acqua piovana, vento e polvere.\n\nÈ importante ricordare che si tratta di sistemi panoramici progettati per proteggere gli spazi esterni, non di facciate completamente ermetiche come un serramento tradizionale.",
  },
  {
    q: "Le vetrate panoramiche sono sicure?",
    a: "Sì. I sistemi professionali utilizzano vetri di sicurezza, come vetro temperato o stratificato, scelti in funzione dell'applicazione e delle normative vigenti.\n\nLa sicurezza dipende anche dalla corretta progettazione, dalla qualità dei componenti e dalla posa eseguita da personale qualificato.",
  },
  {
    q: "Le VEPA hanno i montanti verticali?",
    a: "Una delle caratteristiche principali delle vetrate panoramiche VEPA è proprio la ricerca della massima trasparenza.\n\nMolti sistemi sono progettati senza profili verticali continui tra le ante, permettendo una vista più ampia e una percezione dello spazio molto più aperta.",
  },
  {
    q: "Meglio una VEPA scorrevole o ad impacchettamento?",
    a: "Dipende dall'utilizzo dello spazio.\n\nIl sistema scorrevole permette di modulare facilmente l'apertura delle ante lungo i binari.\n\nIl sistema ad impacchettamento consente invece di raccogliere lateralmente le ante, liberando quasi completamente il passaggio e creando una sensazione di totale apertura.\n\nLa scelta migliore viene valutata in base alla configurazione dell'ambiente.",
  },
  {
    q: "Le VEPA possono essere aperte completamente?",
    a: "Sì. Questa è una delle caratteristiche più apprezzate.\n\nDurante le giornate piacevoli è possibile aprire completamente il sistema, ristabilendo il contatto diretto con l'esterno.",
  },
  {
    q: "Servono permessi per installare una VEPA?",
    a: "Dipende dalla situazione specifica.\n\nÈ necessario valutare:\n• Comune di riferimento;\n• caratteristiche dell'edificio;\n• eventuali vincoli paesaggistici;\n• regolamenti condominiali;\n• caratteristiche dell'intervento.\n\nUna verifica preventiva permette di procedere in modo corretto ed evitare problemi successivi.",
  },
  {
    q: "Posso installare una VEPA in condominio?",
    a: "In molti casi sì, ma è importante valutare il regolamento condominiale e il possibile impatto sul decoro architettonico dell'edificio.\n\nConsigliamo sempre una verifica preventiva prima dell'installazione.",
  },
  {
    q: "Le VEPA aumentano il valore della casa?",
    a: "Una soluzione realizzata con materiali di qualità e progettata correttamente può valorizzare l'immobile, migliorando estetica, comfort e fruibilità degli spazi esterni.\n\nUn terrazzo o un balcone utilizzabile per più mesi all'anno rappresenta spesso un elemento distintivo nella valutazione di un'abitazione.",
  },
  {
    q: "Quanto tempo richiede l'installazione?",
    a: "I tempi dipendono dalla dimensione del progetto e dalla complessità dell'intervento.\n\nDopo il sopralluogo e la definizione della soluzione tecnica, viene programmata la posa secondo le esigenze del cliente.",
  },
  {
    q: "Le vetrate panoramiche richiedono manutenzione?",
    a: "La manutenzione è generalmente semplice.\n\nÈ sufficiente una pulizia periodica dei vetri e delle guide per mantenere nel tempo estetica e funzionalità del sistema.",
  },
  {
    q: "Le VEPA sono adatte anche per ristoranti e attività commerciali?",
    a: "Sì. Sono particolarmente apprezzate da bar, ristoranti, hotel e locali con spazi esterni perché permettono di aumentare il periodo di utilizzo di terrazze e dehors, migliorando il comfort dei clienti.",
  },
  {
    q: "Le vetrate panoramiche VEPA sono detraibili fiscalmente?",
    a: "Le vetrate panoramiche VEPA possono rientrare tra gli interventi agevolabili, qualora siano rispettati tutti i requisiti previsti dalla normativa vigente e le condizioni specifiche richieste per il singolo caso.\n\nLa possibilità di usufruire delle detrazioni dipende da diversi fattori, tra cui:\n• caratteristiche dell'immobile;\n• tipologia dell'intervento realizzato;\n• rispetto delle normative edilizie e urbanistiche applicabili;\n• corretta documentazione fiscale e tecnica;\n• requisiti soggettivi del contribuente.\n\nÈ importante precisare che il beneficio fiscale non rappresenta uno sconto immediato sul prezzo della vetrata, ma una detrazione recuperabile secondo le modalità previste dalla normativa vigente.\n\nPer questo motivo consigliamo sempre di verificare la propria situazione con il proprio consulente fiscale prima di procedere con l'intervento.",
  },
  {
    q: "Perché scegliere VETRO DESIGN ITALIA?",
    a: "Scegliere una vetrata panoramica significa affidarsi a un progetto che deve unire estetica, funzionalità e qualità costruttiva.\n\nIn VETRO DESIGN ITALIA seguiamo ogni realizzazione con attenzione, dalla fase iniziale di analisi degli spazi fino alla progettazione e alla posa finale.\n\nGrazie alla nostra esperienza nel settore delle vetrate panoramiche VEPA e delle lavorazioni del vetro, siamo in grado di proporre soluzioni studiate sulle reali esigenze del cliente, valutando ogni dettaglio tecnico e architettonico.\n\nLa nostra esperienza nella posa in opera ci permette di curare ogni fase dell'installazione con precisione, perché una vetrata di qualità richiede non solo un prodotto eccellente, ma anche una posa eseguita a regola d'arte.\n\nUtilizziamo materiali e componenti di fascia alta, selezionati tra soluzioni affidabili e performanti, per garantire nel tempo:\n• eleganza estetica;\n• sicurezza;\n• funzionalità;\n• durata;\n• comfort di utilizzo.\n\nIl nostro obiettivo non è semplicemente installare una vetrata, ma progettare e realizzare nuovi ambienti da vivere, dove tecnologia, design e trasparenza del vetro si incontrano.\n\nPerché una grande vetrata non è solo una chiusura: è un nuovo modo di vivere lo spazio.",
  },
];

export default function FaqPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div data-testid="faq-page">
      <Seo
        title="FAQ vetrate panoramiche VEPA | Domande frequenti | VETRO DESIGN ITALIA"
        description="Domande frequenti sulle vetrate panoramiche VEPA: cubatura, installazione su balcone, costi, isolamento e sicurezza. Le risposte degli esperti di VETRO DESIGN ITALIA nelle Marche."
        path="/faq-vetrate-panoramiche-vepa"
        jsonLd={jsonLd}
      />
      <Navbar />
      <PageHeader
        eyebrow="FAQ VEPA"
        h1="Domande frequenti sulle vetrate panoramiche VEPA"
        intro="Le risposte alle domande più comuni su cubatura, installazione, costi e prestazioni delle vetrate panoramiche VEPA."
      />
      <section className="px-6 md:px-12 pb-24" data-testid="faq-section">
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-xl font-light">{f.q}</AccordionTrigger>
                <AccordionContent className="text-foreground/75 font-light leading-relaxed text-base whitespace-pre-line">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 bg-black text-white p-8 md:p-10">
            <h2 className="font-serif text-2xl font-light mb-3">Hai altre domande?</h2>
            <p className="text-white/70 font-light mb-6">Contattaci per una consulenza gratuita sulla tua vetrata panoramica.</p>
            <Link
              to="/contatti-vetrate-panoramiche"
              data-testid="faq-cta-contatti"
              className="inline-flex items-center gap-2 bg-white text-black px-7 py-3 text-sm uppercase tracking-wide hover:bg-white/90 transition-colors"
            >
              Richiedi un preventivo
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
